import manchesterCarChargingImage from '../../../assets/images/manchester/car-charging.jpg';
import manchesterCityImage from '../../../assets/images/manchester/manchester-city.jpg';
import manchesterSkylineImage from '../../../assets/images/manchester/manchester-skyline.jpg';

/** @type {import('./cityLandingPageData').CityData} */
const manchester = {
    cityName: 'Manchester',
    searchQuery: 'Manchester',
    heroHeading: "Y'all right our kid? Find EV Chargers in Manchester",
    heroSubheading: "Search for electric vehicle charging points across Manchester. From the city centre to Salford, Stockport, and beyond, EVBuddy helps you find your nearest charger and charge with confidence.",
    searchPlaceholder: "Try a Manchester postcode, e.g. M2...",
    networkSection: {
        heading: "Manchester's Charging Network at Your Fingertips",
        paragraphs: [
            <>Manchester has one of the most rapidly expanding EV charging networks in the North of England, with hundreds of public charge points spread across all 10 boroughs. By 2035 Manchester City Council expects over <a href="https://www.manchester.gov.uk/__data/assets/file/0024/124935/evi_strategy_2024.pdf#page=8" target="_blank" rel="noopener noreferrer">6,000 public chargers</a> to be needed across the city.</>,
            "EVBuddy shows you their locations and latest status, giving you confidence in finding an available charger wherever you are in the area.",
        ],
        image: manchesterCityImage,
        imageAlt: "Electric vehicle charging at a public charge point in Manchester city centre",
    },
    filterSection: {
        heading: "Find the Right Charger for Your Vehicle",
        paragraphs: [
            "Not all chargers are the same. Whether you need a rapid speed charger for a quick top-up near Piccadilly Gardens or a slower overnight charger near Didsbury, EVBuddy allows you to filter by connector type and charging speed so you always find the right match.",
        ],
        image: manchesterCarChargingImage,
        imageAlt: "EV charging in Greater Manchester",
    },
    navigateSection: {
        heading: "Navigate Manchester's Streets with Confidence",
        paragraphs: [
            "Driving around Manchester shouldn't mean worrying about range anxiety. EVBuddy shows you chargers on an interactive map so you can plan your journey across the area, whether you're heading into the city centre, cruising the M60 ring road, or heading out towards Bolton or Bury.",
        ],
        image: manchesterSkylineImage,
        imageAlt: "Manchester skyline",
    },
    seo: {
        title: "EV Charging Points in Manchester | Find Chargers Near You | EVBuddy",
        description: "Find electric vehicle charging points across Manchester. Search for public EV chargers in Manchester City Centre, Salford, Stockport, Didsbury, and Greater Manchester with EVBuddy.",
        keywords: "EV charging Manchester, electric vehicle chargers Manchester, EV charging points Manchester, public EV chargers Manchester, Manchester electric car charging, charge my EV Manchester, rapid chargers Manchester, Greater Manchester EV chargers",
        canonicalUrl: "https://evbuddy.io/manchester",
        ogImage: "https://evbuddy.io/static/media/manchester-city.jpg",
        ogDescription: "Find electric vehicle charging points across Greater Manchester. Search for public EV chargers with EVBuddy.",
    },
};

export default manchester;
